import type { FieldCodec } from 'v5/core/entity-values/values.types';
import { validateField, validation } from './validation';

function isEmpty(value: string | null): boolean {
  return value === null || value === '';
}

/** `pronouns_option_id` ⇄ option id as string (select form value). */
export const pronounsCodec: FieldCodec<'pronouns'> = {
  decode(entity) {
    return entity.pronouns_option_id == null
      ? null
      : String(entity.pronouns_option_id);
  },
  encode(value) {
    return {
      type: 'core-changes',
      changes: [
        {
          column: 'pronouns_option_id',
          value: isEmpty(value) ? null : Number(value)
        }
      ]
    };
  },
  empty() {
    return null;
  },
  isEmpty,
  validate(value, spec) {
    return validateField(value, spec, isEmpty, value =>
      !isEmpty(value) && !Number.isInteger(Number(value))
        ? validation.invalid({ code: 'invalid-option' })
        : validation.valid()
    );
  }
};
